// extracted by mini-css-extract-plugin
export default {"profileDescription":"about_profileDescription__ouOfk","aboutGrid":"about_aboutGrid__For-b","headshot":"about_headshot__mCeDE"};